import clsx from "clsx";
import Image from "next/image";
import * as React from "react";
import { User } from "@/contexts/common/AuthContextProvider";
import { getNameInitials } from "@/utils/library/formatters";

type Props = {
  img?: User["img"];
  name: User["name"];
  className?: string;
  size?: "md" | "xs";
  tone?: "brand" | "neutral";
};

const UserAvatar: React.FC<Props> = ({ img, name, className, size = "md", tone = "brand" }) => {
  if (!img && !name) return null;

  const isXs = size === "xs";
  const boxClass = isXs ? "h-4 w-4" : "h-6 w-6";
  const pixelSize = isXs ? 16 : 24;
  const isNeutral = tone === "neutral";

  if (!img) {
    return (
      <span
        className={clsx(
          "inline-flex",
          boxClass,
          "items-center",
          "justify-center",
          "rounded-full",
          "overflow-hidden",
          isNeutral ? "bg-200" : "bg-panel0",
          className
        )}
      >
        <span
          className={clsx(
            "text-xs",
            "font-medium",
            "leading-none",
            isNeutral ? "text-700" : "text-white"
          )}
        >
          {getNameInitials(name || "")}
        </span>
      </span>
    );
  }

  return (
    <Image
      className={clsx(
        "inline-block",
        boxClass,
        "rounded-full",
        "object-cover",
        className
      )}
      src={img}
      alt={name}
      width={pixelSize}
      height={pixelSize}
    />
  );
};

export default UserAvatar;
